import React from 'react';
import cn from 'classnames';

const styles = {
  wrap: 'mt-6 mb-3 mx-auto flex w-[59%] flex-col items-start justify-start rounded-xl bg-brand-navy/5 p-6 pb-2',
  heading: 'text-left text-lg font-bold text-brand-navy',
  list: 'mt-2 list-disc pl-5 text-left text-sm leading-6 text-gray-700',
};

type ModalInstructionsPanelProps = {
  instructions: string[];
};

const ModalInstructionsPanel = ({ instructions }: ModalInstructionsPanelProps) => {
  if (!instructions || instructions.length === 0) {
    return null;
  }

  return (
    <div id='instruction-wrap' className={cn(styles.wrap)}>
      <div className={cn(styles.heading)}>Instructions</div>
      <ul className={cn(styles.list)}>
        {instructions.map((instruction) => (
          <li key={instruction}>{instruction}</li>
        ))}
      </ul>
    </div>
  );
};

export default ModalInstructionsPanel;
